import { createFileRoute } from '@tanstack/react-router'
import { legalRouteOptions } from '@/lib/cms/legal-route'

export const Route = createFileRoute('/cancellation')(
  legalRouteOptions('cancellation'),
)
